import React, { useState, useEffect } from "react";
import { Button, Divider, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import axios from "axios"
import { Auth } from "aws-amplify";
import { CSVLink } from "react-csv";
import { useTranslation, Trans } from "react-i18next";

import FilterListIcon from '@mui/icons-material/FilterList';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import Table from "../../TableComponent";
import DeleteStudents from "./DeleteStudents";

const Students = ({adminInfo}) => {
  const [loading, setLoading] = useState(true)
  const [studentsData, setStudentsData] = useState([])
  const [std, setStd] = useState("");
  const [divn, setDivn] = useState("");
  const [school, setSchool] = useState("");

  const { t } = useTranslation();
  
  useEffect(() => {
    Auth.currentSession()
    .then((data) => {
      const jwtToken = data.idToken.jwtToken;
      
      const getStudentsData = async(adminId, schoolId) => {
        try {
          const response =  await axios.get("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/admin/"+adminId+"/students?schoolId="+schoolId, {
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': jwtToken
              }
          });
          // console.log("Students Data: ",response.data["students"])
          let cwsnLabels = {
            99: "Not Applicable",
            1: "1-Blindness",
            2: "2-Low-Vision",
            3: "3-Hearing impairment",
            4: "4-Speech and Language",
            5: "5-Locomotor Disability",
            6: "6-Mental illness",
            7: "7-Specific Learning Disabilities",
            8: "8-Cerebral palsy",
            9: "9-Autism Spectrum Disorder",
            10: "10-Multiple Disability incl. deaf blindness",
            11: "11-Leprosy Cured students",
            12: "12-Dwarfism",
            13: "13-Intellectual Disability",
            14: "14-Muscular Dystrophy",
            15: "15-Chronic Neurological conditions",
            16: "16-Multiple Sclerosis",
            17: "17-Thalassemia",
            18: "18-Haemophilia",
            19: "19-Sickle Cell disease",
            20: "20-Acid Attack victim",
            21: "21-Parkinson's disease",
          }
          // adding full name by combining firstName and lastName
          const studentsData = response.data["students"].map(item => ({
            ...item, 
            "studentName": item["studentName"].toUpperCase(),
            "classSection": item["std"] + "-" + item["divn"],
            "cwsn": cwsnLabels[item["cwsn"]]
          })).sort((a,b) => (a.std - b.std || a.divn.localeCompare(b.divn) || a.rollNo - b.rollNo))
          setSchool(adminInfo.admin.schools[0].id)
          setStudentsData(studentsData)
          setLoading(false)
        }
        catch (error) {
          console.log(error)
          setLoading(false)
        }
      }

      getStudentsData(adminInfo.admin.adminId, adminInfo.admin.schools[0].id)
      
    })
    .catch((err) => console.log(err));
    
  }, [adminInfo]);
  
  const columns = [
    {
      key: "studentName",
      headerName: t("commonItems.tableHeader_studentName"),
      width: 80
    },
    {
      key: "orgStudId",
      headerName: t("commonItems.tableHeader_orgStudId"),
      width: 80
    },
    // {
    //   key: "penNo",
    //   headerName: "Student PEN",
    //   width: 80
    // },
    // {
    //   key: "std",
    //   headerName: "Class",
    //   width: 30
    // },
    // { 
    //   key: "divn", 
    //   headerName: "Section", 
    //   width: 30 
    // },
    { 
      key: "classSection", 
      headerName: t("commonItems.tableHeader_classSection"), 
      width: 30 
    },
    { 
      key: "rollNo", 
      headerName: t("commonItems.tableHeader_rollNo"), 
      width: 30 
    },
    { 
      key: "gender", 
      headerName: t("commonItems.tableHeader_gender"), 
      width: 30 
    },
    { 
      key: "cwsn", 
      headerName: t("commonItems.tableHeader_cwsnCategory"), 
      width: 80 
    },
    { 
      key: "options", 
      headerName: "", 
      width: 30,
      options: "students",
      test: adminInfo.test
    }
  ];

  const headers = [
    { label: "Org Student Id", key: "orgStudId"},
    { label: "Class", key: "std" },
    { label: "Section", key: "divn" },
    { label: "Full Name of Student", key: "studentName" },
    { label: "Gender", key: "gender" },
    // { label: "Student PEN (Maximum 12 digit)", key: "penNo"},
    { label: "Roll No", key: "rollNo" },
    { label: "CWSN Category", key: "cwsn" }
  ];
  
  const handleStdChange = (e) => {
    setStd(e.target.value);
  };
  
  const handleDivnChange = (e) => {
    setDivn(e.target.value);
  };

  const handleSchoolChange = (e) => {
    setStd("");
    setDivn("");
    setStudentsData([])
    setSchool(e.target.value);
    if(e.target.value!==""){
      setLoading(true)
      Auth.currentSession()
      .then((data) => {
        const jwtToken = data.idToken.jwtToken;
        
        const getStudentsData = async(adminId, schoolId) => {
          try {
            const response =  await axios.get("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/admin/"+adminId+"/students?schoolId="+schoolId, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': jwtToken
                }
            });
            // console.log("Students Data: ",response.data["students"])
          let cwsnLabels = {
            99: "Not Applicable",
            1: "1-Blindness",
            2: "2-Low-Vision",
            3: "3-Hearing impairment",
            4: "4-Speech and Language",
            5: "5-Locomotor Disability",
            6: "6-Mental illness",
            7: "7-Specific Learning Disabilities",
            8: "8-Cerebral palsy",
            9: "9-Autism Spectrum Disorder",
            10: "10-Multiple Disability incl. deaf blindness",
            11: "11-Leprosy Cured students",
            12: "12-Dwarfism",
            13: "13-Intellectual Disability",
            14: "14-Muscular Dystrophy",
            15: "15-Chronic Neurological conditions",
            16: "16-Multiple Sclerosis",
            17: "17-Thalassemia",
            18: "18-Haemophilia",
            19: "19-Sickle Cell disease",
            20: "20-Acid Attack victim",
            21: "21-Parkinson's disease",
          }
          // adding full name by combining firstName and lastName
          const studentsData = response.data["students"].map(item => ({
            ...item, 
            "studentName": item["studentName"].toUpperCase(),
            "classSection": item["std"] + "-" + item["divn"],
            "cwsn": cwsnLabels[item["cwsn"]]
          })).sort((a,b) => (a.std - b.std || a.divn.localeCompare(b.divn) || a.rollNo - b.rollNo))
            setStudentsData(studentsData)
            setLoading(false)
          }
          catch (error) {
            console.log(error)
            setLoading(false)
          }
        }
        getStudentsData(adminInfo.admin.adminId, e.target.value)
      })
      .catch((err) => console.log(err));
    }
  };

  var filteredStudentsData
  if(std==="" && divn===""){
    filteredStudentsData = studentsData
    // filteredSchoolFacInfo
  }
  else if(std!=="" && divn===""){
    filteredStudentsData = [...studentsData.filter(item => item.std === std)]
  }
  else if(std==="" && divn!==""){
    filteredStudentsData = [...studentsData.filter(item => item.divn === divn)]
  }
  else{
    filteredStudentsData = [...studentsData.filter(item => item.std === std && item.divn === divn)]
  }
  // console.log(studentsData)
  // console.log(filteredStudentsData)

  return (
    <div className="studentsContent innerContent">
      <h2 style={{textAlign: "center", color: "#0288D1", borderRadius: "15px", border: "1px solid"}}>
        {t("admin.students.title")}{adminInfo.test ? <span> - {adminInfo.test.testName}</span>: ""}
      </h2>
      {(adminInfo.test && adminInfo.test.superAdminId===24) && 
        <>
          <h4 style={{ paddingTop:"1rem", color: "#dc3545"}}>
            <Trans 
              i18nKey={"admin.students.studentAdditionInfo_Line1KV"}
              values={{
                date: new Date(adminInfo.test.studListUpdateDate).toLocaleDateString("en-GB", { dateStyle: "long" })
              }}
              components={{
                1: <span style={{color: "var(--text-color)", fontWeight: "normal"}}/>
              }}
            />
          </h4>
          <h4 style={{color: "var(--text-color)", fontWeight: "normal"}}>
            {t("admin.students.studentAdditionInfo_Line2KV")}
          </h4>
        </>
      }
      {/* {(adminInfo.test && adminInfo.test.status===0) && 
        <h4 style={{paddingTop:"1rem", color: "#dc3545"}}>
          Add students using the "Student list upload" button on the left. Last date to finalize student list is {new Date(adminInfo.test.tentativeStartDate).toLocaleDateString("en-GB", { dateStyle: "long" })}. If some student details on UDISE are not available till {new Date(adminInfo.test.tentativeStartDate).toLocaleDateString("en-GB", { day: "2-digit", month: "long" })}, proceed to add only those students whose details are available.
        </h4>
      } */}
      <div className="filters">
        <div className="forms">
          <h4 style={{display: "flex", justifyContent: "center", alignItems: "center", gap: "0.25rem"}}>
            <FilterListIcon fontSize="small"/>
            <span style={{height: "100%"}}>{t("commonItems.filterLabel")}</span> 
          </h4>
          <FormControl sx={{ m: 1, minWidth: 100 }} size="small">
            <InputLabel id="schoolFilterLabel">{t("commonItems.dropdownLabel_school")}</InputLabel>
            <Select
              labelId="schoolFilterLabel"
              id="schoolFilter"
              value={school}
              onChange={handleSchoolChange}
              autoWidth
              label={t("commonItems.dropdownLabel_school")}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {/* getting all unique divn values from data */}
              { adminInfo &&
                adminInfo.admin.schools.map((item, i) => {
                  return <MenuItem key={i} value={item.id}>{item.name}</MenuItem>
                })
              }
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 85}} size="small">
            <InputLabel id="stdFilterLabel">{t("commonItems.dropdownLabel_class")}</InputLabel>
            <Select
              labelId="stdFilterLabel"
              id="stdFilter"
              value={std}
              onChange={handleStdChange}
              autoWidth
              label={t("commonItems.dropdownLabel_class")}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {/* getting all unique std values from data */}
              {divn==="" &&
                [...new Set(studentsData.map(item => item.std))].sort((a, b) => a - b).map((item, i) => {
                return <MenuItem key={i} value={item}>{item}</MenuItem>
                })
              }
              {divn!=="" &&
                [...new Set(studentsData.filter(item => item.divn === divn).map(item => item.std))].sort().map((item, i) => {
                return <MenuItem key={i} value={item}>{item}</MenuItem>
                })
              }
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 100 }} size="small">
            <InputLabel id="divnFilterLabel">{t("commonItems.dropdownLabel_section")}</InputLabel>
            <Select
              labelId="divnFilterLabel"
              id="divnFilter"
              value={divn}
              onChange={handleDivnChange}
              autoWidth
              label={t("commonItems.dropdownLabel_section")}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {/* getting all unique divn values from data */}
              {std==="" &&
                [...new Set(studentsData.map(item => item.divn))].sort().map((item, i) => {
                return <MenuItem key={i} value={item}>{item}</MenuItem>
                })
              }
              {std!=="" &&
                [...new Set(studentsData.filter(item => item.std === std).map(item => item.divn))].sort().map((item, i) => {
                return <MenuItem key={i} value={item}>{item}</MenuItem>
                })
              }
            </Select>
          </FormControl>
        </div>
      </div>
      <div className="tabs">
        <Button variant="contained" color="info" startIcon={<FileDownloadIcon />} sx={{ placeSelf: "start" }}>
          <CSVLink data={studentsData.filter(item => item.rollNo !== 0)} headers={headers} filename={"StudentsDataAdmin.csv"}>
            {t("commonItems.buttonLabel_csvDownload")}
          </CSVLink>
        </Button>
        {school && <DeleteStudents adminInfo={adminInfo} schoolId={school}/>}
      </div>
      <Divider />
      <div className="table">
        <Table
          columns={columns}
          tableData={filteredStudentsData}
          orderBy={[]}
          tableHeight={(adminInfo.test && adminInfo.test.superAdminId===24) ? "calc(100vh - 383px)" : "calc(100vh - 318px)"} 
          loading={loading}
        />
      </div>
    </div>
  );
};

export default Students;
